import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { ItemTypePopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface ItemTypeUserDefinedField {
    itemTypeId: number | undefined
    userDefinedFieldId: number
}

const AddItemTypeUserDefinedFieldPopup: React.FC<ItemTypePopupProps> = ({ show, onHide, itemTypeId }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<ItemTypeUserDefinedField>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<ItemTypeUserDefinedField>({
        itemTypeId: itemTypeId,
        userDefinedFieldId: 0,
    });

    const userDefinedFields = useSelectListOptions('api/v1/selectlist/UserDefinedFields', '-- Select user-defined field');

    function submit() {
        if (formData) {
            DataService
                .create<ItemTypeUserDefinedField>(`api/v1/ItemTypeUserDefinedFields/`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && response.data)
                        setFormData(response.data);

                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'userDefinedFieldId', label: 'User-defined field', labelSize: 4, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add user-defined field'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('userDefinedFieldId')} options={userDefinedFields} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddItemTypeUserDefinedFieldPopup;